import React from 'react';

import CDNImage from '../../common/cdn-image';

import '../../../styles/shop/additional-photos.scss';

const AdditionalPhotos = (props) => (
  <div className="product-view__additional-images">
    {props.paths.split('\n').map((line, idx) => (
      <div className="image-cell-wrapper">
        <button
          className="image-cell"
          onClick={() => props.showLightbox(idx + 1) }
        >
          <CDNImage imagePath={line} alt={`Additional Product Image #${idx + 1}`} width={200} />
        </button>
      </div>
    ))}
  </div>
);

export default AdditionalPhotos;